export const blockIconsAudioandvideoPause = (
	<span className='material-symbols-outlined'>pause</span>
);
